import { render, staticRenderFns } from "./MainStatusTable.vue?vue&type=template&id=5bd5e86a"
import script from "./MainStatusTable.vue?vue&type=script&lang=js"
export * from "./MainStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports